module.exports = "/assets/fb6b904ced29f2760274706d94a42cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZA.png
// module id = 764
// module chunks = 0